import React from "react";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
} from "@mui/material";
import Libelle from "../../_i18n/fr.json";
import { HeaderDonnees } from "./Tableau";

export function HeaderTableauFromJSON(json: any): HeaderDonnees {
  return {
    id: json["id"],
    idTriable: json["idTriable"] || null,
    libelle: json["libelle"],
    isTriable: json["isTriable"],
  };
}

interface Props {
  trierPar: string;
  ordreDeTrie: "asc" | "desc";
  onTrier: (event: React.MouseEvent, idColonne: string) => void;
  headerDonnees: HeaderDonnees[];
}

const Header: React.FC<Props> = ({
  trierPar,
  ordreDeTrie,
  onTrier,
  headerDonnees,
}) => {
  const dataHeader = headerDonnees.map(HeaderTableauFromJSON);

  return (
    <TableHead>
      <TableRow>
        {dataHeader.map((n) => {
          const id = n.idTriable || n.id;
          return (
            <TableCell key={n.id} component="th" scope="col" className="header">
              {n.isTriable ? (
                <Tooltip title={`${Libelle.tableau.header.trier} ${n.libelle}`}>
                  <TableSortLabel
                    className="headerSort"
                    active={trierPar === id}
                    classes={{
                      active: "active",
                    }}
                    direction={ordreDeTrie}
                    onClick={(event) => onTrier(event, id)}
                  >
                    {n.libelle}
                  </TableSortLabel>
                </Tooltip>
              ) : (
                <>{n.libelle}</>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default Header;
